<template>
  <div id="downloadsCat">
    <mu-content-block v-if="isLoading" style="text-align: center">
      <mu-circular-progress :size="32"></mu-circular-progress>
      <br/>
      <span v-text="$t('message.loadingText')"></span>
    </mu-content-block>
    <div class="cat-view" v-if="!isLoading">
      <div class="cat-bg" :style="'background-image: url('+ data.cat.image +');'">
        <div class="cat">
          <h1 v-once v-text="data.cat.name"></h1>
          <div class="desc" v-once v-text="data.cat.desc"></div>
        </div>
      </div>
      <div class="content">
        <mu-card>
          <mu-card-header :title="data.cat.name" :subTitle="data.cat.desc" titleClass="largeTitle" />
          <mu-list>
            <mu-list-item class="item" v-for="download, index in data.downloads" :key="`download-${index}`" :title="download.title" :describeText="download.desc" @click="openLink(download)">
              <div slot="leftAvatar">
                <mu-avatar :src="download.image_url" />
              </div>
              <div slot="right">
                <mu-icon value="file_downloads" color="#0179d5" />
              </div>
              <mu-divider />
            </mu-list-item>
          </mu-list>
        </mu-card>
      </div>
    </div>
  </div>
</template>
<script>
  import HCPMixin from '../../mixins/HCPMixin';
  import hcpApi from '../../api/Hcp';
  export default {
    mixins: [HCPMixin],
    watch: {
      "$route": function() {
        let self = this;
        self.initMounted();
      }
    },
    data() {
      return {
        isLoading: true,
        data: {}
      }
    },
    methods: {
      openLink(res) {
        window.open(res.link, '_blank');
      },
      getCategory() {
        let self = this;
        hcpApi.getResourceCatDownloads(self.$route.params.slug).then(response => {
          self.data = response.data;
          self.isLoading = false;
        });
      },
      initMounted() {
        let self = this;
        self.isLoading = true;
        self.getCategory();
      }
    },
    mounted() {
      let self = this;
      self.initMounted();
    }
  }
</script>
<style lang="less">
  #downloadsCat {
    margin: -24px;
    .cat-bg {
      display: flex;
      align-items: flex-end;
      -webkit-align-items: flex-end;
      -moz-align-items: flex-end;
      height: 300px;
      padding: 24px 24px 48px;
      background: no-repeat center center;
      background-size: cover;
      position: relative;
      &:before {
        content: '';
        width: 100%;
        height: 100%;
        background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.5), rgba(0, 0, 0, 0.5));
        position: absolute;
        top: 0;
        left: 0;
      }
      .cat {
        color: #FFF;
        position: relative;
        z-index: 1;
        h1 {
          font-size: 32px;
          color: #FFF;
        }
        .desc {
          font-size: 16px;
          color: fade(#FFF, 60%);
        }
      }
    }
    .content {
      .mu-card {
        padding: 0 0 32px;
        margin: 32px 16px 46px;
        .mu-card-title {
          margin: 0 0 8px;
          font-weight: 500;
        }
        .mu-card-sub-title {
          font-size: 16px;
        }
      }
    }
    .item {
      float: left;
      width: 50%;
      &:nth-child(2n + 1) {
        clear: both;
      }
      @media only screen and (max-width: 768px) {
        float: none;
        width: auto;
      }
      .mu-item {
        &.show-left {
          padding-left: 135px;
        }
        &.show-right {
          padding-right: 90px;
        }
        .mu-item-text {
          max-height: 50px!important;
          line-height: 1.5;
          margin: 8px 0 16px;
          color: fade(#000, 70%)!important;
          word-break: break-word;
        }
        .mu-divider {
          display: block;
          margin: 10px 0 0;
        }
      }
      .mu-avatar {
        width: 100px;
        height: auto;
        position: relative;
        top: 10px;
        img {
          height: auto;
          border-radius: 2px;
          box-shadow: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// DownloadsCategory.vue?760b5349